import createVueApp from '@/common/createApp'

Styxie.Initializers.GmbMultiLocationMedia = {
  index: async(props) => {
    const { default: MultiLocationMediaIndex } = await import('@/vue_widgets/gmb/multi_location_media/index.vue')
    createVueApp(MultiLocationMediaIndex, { props })
  },
  show: async(props) => {
    const { default: MultiLocationMediaShow } = await import('@/vue_widgets/gmb/multi_location_media/show.vue')
    createVueApp(MultiLocationMediaShow, { props })
  },
  new: async(props) => {
    const { default: MultiLocationMediaNew } = await import('@/vue_widgets/gmb/multi_location_media/new.vue')
    createVueApp(MultiLocationMediaNew, { props })
  }
}
